import { getTranslateNumber } from '$common/utils/number';
import moment from "moment";
const moneyFlagMap = {
  USD: "$",
  CNY: '￥'
};
const execTimeStampStr = (val, key) => {
  return !!val && /^\d+$/.test(val.toString()) ? Number(val) : val
}

export const filters = {
  DateFmt:(val, fmt ='DD/MM/YYYY HH:mm:ss') => {
    //console.log(val)
    if (!val && val !== 0) {
      return '-'
    }

    const date = new Date(val);
    //获得当地时间偏移的毫秒数
    const localOffset = date.getTimezoneOffset() * 60000;
    //utc 即 GMT 时间
    const utc = date.getTime() + localOffset;
    //柬埔寨东 7 区
    const kmTime = utc + (3600000 * 7);
    const momentDate = moment(execTimeStampStr(kmTime))
    console.log('momentDate: ' + momentDate)
    console.log('momentDate fmt: ' + val)
    console.log('isValid: ' + momentDate.isValid())
    console.log('momentDate.format(fmt)' + momentDate.format(fmt))
    return momentDate.isValid() ? momentDate.format(fmt) : '-'
  },
  AmtDecimalsFmt: (num, n = 2) => {
    // let n = 2 //设置保留的小数位数
    num = parseFloat((num + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    let l = num
      .split(".")[0]
      .split("")
      .reverse();
    let r = num.split(".")[1];
    let t = "";
    for (let i = 0; i < l.length; i++) {
      t += l[i];
    }
    return (
      t
        .split("")
        .reverse()
        .join("") +
      "." +
      r
    );
  },
  Money: moneyObj => {
    const __moneyObj = {
      amount: moneyObj?.amount ?? 0,
      currency: moneyObj?.currency ?? 'USD'
    };
    return `${moneyFlagMap[__moneyObj.currency]}${getTranslateNumber(__moneyObj.amount)}`;
  },
  //瑞尔金额
  KhrMoney:(val,symbol='៛')=>{
    val = val || 0
    //向上取整
    return symbol+Math.ceil(val).toLocaleString(undefined, {maximumFractionDigits: 2})
  },
};
export default {
  install() {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key]);
    });
  }
};
